import {InjectionToken} from '@angular/core'

export interface ICameraFactory {
  getAvailableVideoInputs(): Promise<MediaDeviceInfo[]>

}

export const CAMERA_FACTORY = new InjectionToken<ICameraFactory>('cameraFactory')